import { createStore } from 'vuex';
import axios from 'axios';
import VuexPersistence from 'vuex-persist';

let intervalId = null;
let lostRewardIntervalId = null;

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  reducer: state => ({
    userData: state.userData,
    clickedTasks: state.clickedTasks
  }) // Sadece gerekli olan state'i saklar
});

export default createStore({
  state: {
    userData: {},
    virtualBalance: 0,
    rewardPerSecond: 0,
    status: false,
    reward: 0,
    dailyStf: 0,
    isClaimButtonActive: false,
    lostReward: 0,
    developmentMode: false,
    interval: 60,
    clickedTasks: []
  },
  mutations: {
    SET_USER_DATA(state, data) {
      state.userData = {
        ...data,
        reward: parseFloat(data.reward),
        lost_reward: parseFloat(data.lost_reward),
        current_balance: parseFloat(data.current_balance),
        virtual_balance: parseFloat(data.virtual_balance),
        reward_per_second: parseFloat(data.reward_per_second),
        daily_stf: parseFloat(data.daily_stf)
      };
      state.virtualBalance = parseFloat(data.virtual_balance);
      state.rewardPerSecond = parseFloat(data.reward_per_second);
      state.status = data.status;
      state.reward = parseFloat(data.reward);
      state.dailyStf = parseFloat(data.daily_stf);
      state.lostReward = parseFloat(data.lost_reward);
      state.isClaimButtonActive = state.status || state.reward >= state.dailyStf;
      state.developmentMode = data.development_mode;
      state.interval = parseInt(data.interval);

      if (state.reward >= state.dailyStf && !state.developmentMode) {
        if (!lostRewardIntervalId) {
          lostRewardIntervalId = setInterval(() => {
            state.lostReward += state.rewardPerSecond;
            state.userData.lost_reward = state.lostReward;
          }, 1000);
        }
      } else {
        clearInterval(lostRewardIntervalId);
        lostRewardIntervalId = null;
      }
    },
    UPDATE_VIRTUAL_BALANCE(state) {
      if (!state.status && state.reward < state.dailyStf) {
        state.virtualBalance += state.rewardPerSecond;
        state.reward += state.rewardPerSecond;
        state.userData.reward += state.rewardPerSecond;
        if (state.userData.reward >= state.dailyStf) {
          state.userData.reward = state.dailyStf;
          state.isClaimButtonActive = true;

          if (!state.developmentMode && !lostRewardIntervalId) {
            lostRewardIntervalId = setInterval(() => {
              state.lostReward += state.rewardPerSecond;
              state.userData.lost_reward = state.lostReward;
            }, 1000);
          }
        } else {
          state.isClaimButtonActive = false;
        }
      }
    },
    START_LOST_REWARD_UPDATE(state) {
      if (!state.developmentMode && !lostRewardIntervalId) {
        lostRewardIntervalId = setInterval(() => {
          state.lostReward += state.rewardPerSecond;
          state.userData.lost_reward = state.lostReward;
        }, 1000);
      }
    },
    SET_CLAIM_BUTTON_ACTIVE(state, isActive) {
      state.isClaimButtonActive = isActive;
    },
    RESET_REWARD_STATE(state) {
      state.reward = 0;
      state.lostReward = 0;
      state.userData.reward = 0;
      state.userData.lost_reward = 0;
      state.isClaimButtonActive = false;
      clearInterval(lostRewardIntervalId);
      lostRewardIntervalId = null;
    },
    STOP_VIRTUAL_BALANCE_UPDATE() {
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
      if (lostRewardIntervalId) {
        clearInterval(lostRewardIntervalId);
        lostRewardIntervalId = null;
      }
    },
    STOP_LOST_REWARD_UPDATE() {
      if (lostRewardIntervalId) {
        clearInterval(lostRewardIntervalId);
        lostRewardIntervalId = null;
      }
    },
    ADD_CLICKED_TASK(state, taskId) {
      if (!state.clickedTasks.includes(taskId)) {
        state.clickedTasks.push(taskId);
      }
    },
    REMOVE_CLICKED_TASK(state, taskId) {
      state.clickedTasks = state.clickedTasks.filter(id => id !== taskId);
    }
  },
  actions: {
    fetchUserData({ commit, dispatch }, { telegramId, username, ref }) {
      axios.get(`https://sys.bitherin.com/telegram-webapp?telegram_id=${telegramId}&username=${username}&ref=${ref}`)
          .then(response => {
            commit('SET_USER_DATA', response.data);
            dispatch('startVirtualBalanceUpdate');
          }).catch(error => {
        console.error('Error fetching user data:', error);
      });
    },
    startVirtualBalanceUpdate({ commit }) {
      if (intervalId) {
        clearInterval(intervalId);
      }
      intervalId = setInterval(() => {
        commit('UPDATE_VIRTUAL_BALANCE');
      }, 1000);
    },
    claimReward({ commit, dispatch }, { telegramId, username, ref, userId }) {
      axios.post('https://sys.bitherin.com/claim-reward', {
        telegram_id: telegramId,
        username: username,
        ref: ref,
        user_id: userId
      }).then(response => {
        console.log('Response:', response.data);
        commit('RESET_REWARD_STATE');
        dispatch('fetchUserData', { telegramId, username, ref });
      }).catch(error => {
        console.error('Error:', error);
      });
    }
  },
  getters: {
    userData: state => state.userData,
    virtualBalance: state => state.virtualBalance,
    rewardPerSecond: state => state.rewardPerSecond,
    status: state => state.status,
    reward: state => state.reward,
    dailyStf: state => state.dailyStf,
    isClaimButtonActive: state => state.isClaimButtonActive,
    lostReward: state => state.lostReward,
    interval: state => state.interval,
    clickedTasks: state => state.clickedTasks
  },
  plugins: [vuexLocal.plugin]
});
